var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddUser = function SvgAddUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.5 12.396a8.54 8.54 0 0 1 6.008 2.475A8.43 8.43 0 0 1 17 20.84a.443.443 0 0 1-.447.444H.447A.443.443 0 0 1 0 20.84a8.43 8.43 0 0 1 2.492-5.969A8.54 8.54 0 0 1 8.5 12.395m0-11.112c1.305 0 2.557.515 3.48 1.432a4.87 4.87 0 0 1 1.44 3.457c0 1.296-.518 2.54-1.44 3.457A4.94 4.94 0 0 1 8.5 11.06 4.94 4.94 0 0 1 5.02 9.63a4.87 4.87 0 0 1-1.44-3.457c0-1.297.518-2.54 1.44-3.457A4.94 4.94 0 0 1 8.5 1.284M19.13 0c.433 0 .784.351.784.784v1.841l1.775-.007c.472 0 .854.351.854.784s-.382.784-.854.784l-1.775.007V6a.784.784 0 0 1-1.568 0V4.193H16.5a.784.784 0 0 1 0-1.568h1.846V.785c0-.434.351-.785.784-.785"
  })));
};
export default SvgAddUser;